





















import { Watch, Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class InputChoice extends Vue {
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly options!: Array<{label: string|null, value: string|number}>
    @Prop() readonly value!: string
    @Prop({ type: Boolean, default: false }) readonly labelOutside!: boolean
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    internalValue: string = null

    created() {
        this.onExternalChange()
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    onInternalChange(): void {
        this.$emit('input', this.internalValue)
    }

    get componentClass(): object {
        return {
            'input-choice': true,
        }
    }
}
